import React from 'react';
import Translation from '../translation/translation';

function WheelAlignmentInfoLightBoxHeader() {
    return (
        <div className="wheel-alignment-info-light-box__header wheel-alignment-info-light-box-header">
            <Translation
                translationKey="wheel-alignment-info-light-box-header"
                className="wheel-alignment-info-light-box-header__headline"
            />
        </div>
    );
}

export { WheelAlignmentInfoLightBoxHeader };
